var some;

if (Array.prototype.some) {
  some = Array.prototype.some;
} else {
  some = function some(fun) {
    var t = Object(this),
        len = t.length >>> 0,
        i;

    for (i = 0; i < len; i++) {
      if (i in t && fun.call(this, t[i], i, t)) {
        return true;
      }
    }

    return false;
  };
}

export { some as default };